/**
 * Scheduler type determines how the schedule is evaluated
 */
export const SchedulerType = {
  /** Always active (default behavior) */
  Always: 'always',
  /** Active at a specific date/time */
  DateTime: 'datetime',
  /** Active during a specific period (from-to) */
  Period: 'period',
  /** Active based on match conditions */
  Condition: 'condition',
} as const;
export type SchedulerType = (typeof SchedulerType)[keyof typeof SchedulerType];

/**
 * Match-based conditions for scheduling
 */
export const SchedulerCondition = {
  /** Active when there are matches scheduled for today */
  GamesForDay: 'gamesForDay',
  /** Active when there are no matches scheduled for today */
  NoGamesForDay: 'noGamesForDay',
  /** Active when there is at least one live match */
  HasLiveGame: 'hasLiveGame',
  /** Active when there are no live matches */
  NoLiveGame: 'noLiveGame',
} as const;
export type SchedulerCondition = (typeof SchedulerCondition)[keyof typeof SchedulerCondition];

/**
 * Configuration for scheduled items (pages or components)
 */
export type SchedulerConfig = {
  /** The type of scheduling */
  type: SchedulerType;
  /** Start date for DateTime or Period types (ISO string) */
  startDate?: string;
  /** End date for Period type (ISO string) */
  endDate?: string;
  /** Condition for Condition type */
  condition?: SchedulerCondition;
};

/**
 * Live match-condition status, polled by `useSchedulerStatusQuery` and evaluated
 * client-side by `isComponentVisible` (packages/ui/src/utils/schedulerVisibility.ts).
 */
export type SchedulerStatus = {
  hasLiveGame: boolean;
  hasGamesForDay: boolean;
};
